import { useEffect } from "react"
import { FOCUS_COMMAND, BLUR_COMMAND, COMMAND_PRIORITY_LOW } from "lexical"
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext"
import { $generateHtmlFromNodes } from "@lexical/html"

// This plugin is tracking editor focus state and updates the previous state of the editor content ob blur
const FocusTrackerPlugin = ({
  setHasFocus,
  setPrevData,
}: {
  setHasFocus: (prev: boolean) => void
  setPrevData: (prev: string) => void
}) => {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    const removeFocusListener = editor.registerCommand(
      FOCUS_COMMAND,
      () => {
        setHasFocus(true)
        return false // Prevents other listeners from handling this command
      },
      COMMAND_PRIORITY_LOW
    )

    const removeBlurListener = editor.registerCommand(
      BLUR_COMMAND,
      () => {
        setPrevData($generateHtmlFromNodes(editor))
        setHasFocus(false)
        return false
      },
      COMMAND_PRIORITY_LOW
    )

    return () => {
      removeFocusListener()
      removeBlurListener()
    }
  }, [editor])

  return null
}

export default FocusTrackerPlugin
